"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable newline-per-chained-call */
const core_1 = require("@angular/core");
const moment_1 = __importDefault(require("moment"));
const sales_api_service_1 = require("../../../shared/api/sales-api.service");
const enums_1 = require("../@shared-types/vehicle/enums");
let AnalysisComponent = class AnalysisComponent {
    constructor(salesAPIService) {
        this.salesAPIService = salesAPIService;
        this.kpis = {
            soldVehicles: {
                prevPeriod: null,
                thisPeriod: null,
                difference: null,
            },
            handover: {
                total: null,
                overdue: null,
            },
        };
        this.initHandoverVehicles = () => __awaiter(this, void 0, void 0, function* () {
            const total = yield this.salesAPIService.getExportCount({
                $and: [
                    { 'vehicleData.availability.code': enums_1.EAvailabilityCode.Sold },
                    { 'vehicleData.inventory.state': enums_1.EInventoryState.Stock },
                ],
            });
            const overdue = yield this.salesAPIService.getExportCount({
                $and: [
                    { 'vehicleData.availability.code': enums_1.EAvailabilityCode.Sold },
                    { 'vehicleData.inventory.state': enums_1.EInventoryState.Stock },
                    {
                        'vehicleData.availability.sellData.plannedHandover': {
                            $lt: (0, moment_1.default)().toDate(),
                        },
                    },
                ],
            });
            this.kpis.handover.total = total;
            this.kpis.handover.overdue = overdue;
        });
        this.initSoldVehicles = () => __awaiter(this, void 0, void 0, function* () {
            const thisPeriod = yield this.salesAPIService.getExportCount({
                'vehicleData.availability.sellData.contractDate': {
                    $gte: (0, moment_1.default)().set('month', 0).set('date', 1).toDate(),
                    $lte: (0, moment_1.default)().toDate(),
                },
            });
            const prevPeriod = yield this.salesAPIService.getExportCount({
                'vehicleData.availability.sellData.contractDate': {
                    $gte: (0, moment_1.default)().set('month', 0).set('date', 1).subtract(1, 'year').toDate(),
                    $lte: (0, moment_1.default)().subtract(1, 'year').toDate(),
                },
            });
            this.kpis.soldVehicles.prevPeriod = prevPeriod;
            this.kpis.soldVehicles.thisPeriod = thisPeriod;
            if (thisPeriod > prevPeriod) {
                const difference = (thisPeriod - prevPeriod) / prevPeriod;
                this.kpis.soldVehicles.difference = difference * 100;
            }
            else {
                const difference = (prevPeriod - thisPeriod) / prevPeriod;
                this.kpis.soldVehicles.difference = difference * -100;
            }
        });
        this.initSoldVehicles();
        this.initHandoverVehicles();
    }
};
AnalysisComponent = __decorate([
    (0, core_1.Component)({
        selector: 'analysis',
        templateUrl: require('./analysis.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof sales_api_service_1.SalesAPIService !== "undefined" && sales_api_service_1.SalesAPIService) === "function" ? _a : Object])
], AnalysisComponent);
exports.default = AnalysisComponent;
